"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../../Header.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Subtitle to be shown in the <i>Header</i> component: 
 * this component will be used as a child of
 * <i>&lt;Header.Title&gt;</i> component.
 * 
 * @visibleName Header.Title.SubTitle
 */
var SubTitle = function SubTitle(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
    className: "rolext-header-title-sub",
    style: style,
    children: children
  });
};

SubTitle.propTypes = {
  /**
   * A CSS Style to render the subtitle in the header title
   */
  style: _propTypes.default.object,

  /**
   * The children elements having the subtitle to 
   * be shown in the header title
   */
  children: _propTypes.default.node
};
var _default = SubTitle;
exports.default = _default;